import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=756280a4&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
import style0 from "./Create.vue?vue&type=style&index=0&id=756280a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756280a4",
  null
  
)

export default component.exports